import { render, staticRenderFns } from "./pointDialog.vue?vue&type=template&id=32ae98bc&scoped=true&"
import script from "./pointDialog.vue?vue&type=script&lang=js&"
export * from "./pointDialog.vue?vue&type=script&lang=js&"
import style0 from "./pointDialog.vue?vue&type=style&index=0&id=32ae98bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ae98bc",
  null
  
)

export default component.exports